<template>
  <div
    id="app"
    class="ff-regular"
    :class="{
      'is-loading': showLoading,
      'pb-62': showBar && tabBarList.length
    }"
  >
    <common-title
      v-if="showTitle()"
      :title="webTitle"
      :right-menu="rightMenu"
    ></common-title>
    <!-- 套餐到期 -->
    <div class="sku-tip">
      <common-bar
        @click="clickBarHandler"
        @close="closeBarHandler"
        v-if="topPromptStatus.showPrompt"
        :icon="'&#xe61c;'"
        >{{ skuTipContent }}</common-bar
      >
    </div>
    <!-- 只缓存命中的路由 最大缓存数量为5个 即界面打开层级不能超过5个 -->
    <keep-alive :include="cachedViews" :max="5">
      <router-view
        ref="routerView"
        class="scroll"
        :class="{ invisible: showLoading }"
      ></router-view>
    </keep-alive>
    <common-tab-bar v-show="showBar && tabBarList.length"></common-tab-bar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import API from '@/api'
import {
  getItem,
  changeOperUserRoleTypes,
  getTitle,
  showTitle,
  timeFormat,
  disableDoubleClick
} from '@/utils/comUtils'
import { disableWebViewBounce } from '@/utils/mcSdkUtils'
import { commonTitle, commonBar, commonTabBar } from '@/components'
import { DEVICE_TYPE, TABBAR_ROUTER_CONFIG } from './utils/constUtils'
require('./assets/css/reset.css')
require('./assets/css/flex.scss')
require('./assets/css/common.scss')
require('./assets/css/iconfont.css')

export default {
  name: 'App',
  components: { commonTitle, commonBar, commonTabBar },
  data() {
    return {
      showTitle,
      img: require('@/assets/images/heardTip.png'),
      showCommonLayer: true,
      ifCommonLayer: false,
      isNew: false,
      itvl: null,
      isUpdating: false,
      showLoading: true,
      startTime: +new Date(),
      webTitle: '',
      rightMenu: [{ name: '更多', value: 1 }],
      immediateTrack: false
    }
  },
  computed: {
    // 套餐到期
    ...mapState('expireSku', ['topPromptStatus', 'skuTipContent', 'isHome']),
    tabBarList() {
      return this.$store.getters.routeForTabbar
    },
    cachedViews() {
      return this.$store.getters.cachedViews.reduce((_names, obj) => {
        return _names.concat(obj.name)
      }, [])
    },
    showBar() {
      const route = TABBAR_ROUTER_CONFIG.find(path => {
        // 比较原始路由，去掉/full或者/gray前缀
        if (
          this.$route.path.startsWith('/full') ||
          this.$route.path.startsWith('/gray')
        ) {
          const realpPath = this.$route.path.substring(5)
          return realpPath === path
        }
        return this.$route.path === path
      })
      return !!route && this.$store.state.tabbarShow
    }
  },
  mounted() {
    disableWebViewBounce()
    disableDoubleClick()
    this.$root.$on('onHideLoading', () => (this.showLoading = false))
  },
  watch: {
    // cachedViews: {
    //   deep: true,
    //   handler(val) {
    //     console.log(val.join(','))
    //   }
    // },
    $route: {
      deep: true,
      handler(to, from) {
        let { modular, modularObj, immediate } = to.meta
        this.immediateTrack = immediate
        // 通知/欢迎词 (publishType) 亲情通话机/班牌都是同一套代码 但是参数不一样 具体界面判断过期提示
        if (+modular === 27) {
          // 班牌和亲情通话管理做下额外判断
          modular = (this.$store.state.deviceManageType || []).some(
            item => item === DEVICE_TYPE.T1
          )
            ? 27
            : 32
        }
        // 通知和欢迎词页额外判断
        if (modular === 23) {
          let { publishType } = to.query
          modular = modularObj[publishType]
        }
        this.initExpireSkuPrompt({
          ...(to.meta || {}),
          modular
        }) // 重置顶部提示

        this.rightMenu = []
        this.webTitle = document.title || getTitle()
        this.handlerDataBoard(to)
        if (from.path === '/' && !to.meta.skipAnimation) {
          const endTime = +new Date()
          if (endTime - this.startTime < 2600) {
            setTimeout(() => {
              this.showLoading = false
            }, 2600 - (endTime - this.startTime))
          } else {
            this.showLoading = false
          }
        } else if (
          (from.name === 'PageDeviceDetailName' ||
            from.name === 'PageVehicleSettingParkingLot') &&
          to.path === '/'
        ) {
          this.showLoading = true
          this.startTime = +new Date()
        } else {
          this.showLoading = false
        }
      }
    }
  },
  beforeDestroy() {
    this.savePageViewBatch()
    clearInterval(this.itvl)
  },
  methods: {
    handlerDataBoard(to) {
      const _getters = (this && this.$store && this.$store.getters) || {}
      const _commit = (this && this.$store && this.$store.commit) || null
      const _pageList = _getters.pageList || []
      const _meta = to.meta
      const _newPage = changeOperUserRoleTypes({
        campusId:
          getItem('currentCapmusId') ||
          (_getters.currentCapmus || {}).tpId ||
          '',
        moduleType: _meta.field
          ? _meta.modularObj[(to.query || {})[_meta.field]]
          : _meta.modular,
        operUserRoleTypes: `${_getters.currentRole || ''}`,
        pageName: _meta.field
          ? _meta.infoObj[(to.query || {})[_meta.field]]
          : _meta.info || _meta.title || '',
        pageUrl: to.path,
        viewStartTime: new Date().getTime()
      })
      _pageList.length < 200 &&
        _commit &&
        _commit('pageList', [..._pageList, _newPage])
      if (this.immediateTrack || (_getters.pageList || []).length >= 20) {
        if (this.isUpdating) {
          return
        }
        this.savePageViewBatch()
      }
    },
    updataPageView() {
      this.itvl = setInterval(() => {
        if (this.isUpdating) {
          return
        }
        this.savePageViewBatch()
      }, this.$store.getters.saveCycle * 1000)
    },
    // 批量保存页面浏览记录
    savePageViewBatch() {
      // 过滤开发测试环境的无效请求
      if (process.env.NODE_ENV !== 'production') {
        return false
      }
      const _getters = (this && this.$store && this.$store.getters) || {}
      const _commit = (this && this.$store && this.$store.commit) || null
      const _pageList = _getters.pageList || []
      if (!_pageList.length) {
        return false
      }
      this.isUpdating = true
      const appType = this.$route.query && this.$route.query.sourceType ? 4 : 1
      return new Promise((resolve, reject) => {
        const _param = {
          orgId: (_getters.token || {}).orgId || '',
          campusId:
            getItem('currentCapmusId') ||
            (_getters.currentCapmus || {}).tpId ||
            '',
          operUserRoleTypes: `${_getters.currentRole || ''}`,
          appType,
          list: _pageList
        }
        try {
          API.savePageViewBatch(_param)
            .then(res => {
              _commit && _commit('pageList', [])
              const _res = res || {}
              this.isUpdating = false
              resolve(_res)
            })
            .catch(err => {
              this.isUpdating = false
              reject(err)
            })
        } catch (error) {
          console.log(error)
        }
      })
    },

    // 关闭顶部提示
    ...mapMutations('expireSku', [
      'setExpireSkuLocal', // 关闭时设置本地存储
      'initExpireSkuPrompt', // 重置顶部提示内容
      'setExpireSkuDialog', // 设置即将到期弹窗
      'showExpireSkuDialog'
    ]),
    closeBarHandler() {
      this.setExpireSkuLocal({
        showPrompt: false,
        time: timeFormat(new Date(), 'YYYYMMDD')
      })
    },
    clickBarHandler() {
      if (this.isHome && !['8'].includes(getItem('platformSource'))) {
        this.showExpireSkuDialog(true)
        this.setExpireSkuDialog()
        this.$refs.routerView.showExpireSkuDialog()
      } else if (this.$route.name === 'PageFamilyCall') {
        this.$router.push({
          path: `/classcard/familycall/device`
        })
      } else {
        window.open(
          'dingtalk://dingtalkclient/page/link?pc_slide=true&url=https%3A%2F%2Fh5.dingtalk.com%2Fservice-group%2Findex.html%3FjoinGroupCode%3Dp3cAnJVnxMPO25P9SiicW0gn2rdjnmFJLpI77eCEPo6MiS5ZHAA1IUiimqLrANZgjfK%23%2Fjoin-group'
        )
      }
    }
  }
}
</script>

<style lang="scss">
// @font-face {
//   font-family: ding;
//   src: url('@/index/assets/font/DIN.ttf');
// }
@font-face {
  font-family: ding-bold;
  src: url('~@/assets/font/DIN-Alternate-Bold.otf');
}
@font-face {
  font-family: ding-condensed-bold;
  src: url('~@/assets/font/DIN-Condensed-Bold.ttf');
}
#__vconsole .vc-switch {
  top: 57%;
  right: 0;
  width: 80px;
  text-align: center;
  height: 30px;
}
#app {
  display: flex;
  flex-direction: column;

  height: 100%;
  box-sizing: border-box;
  color: #171a1d;
  &.is-loading {
    background-image: url('~@/assets/images/start.gif');
    background-size: 200px;
    background-repeat: no-repeat;
    background-position: center calc(calc(100vh - 200px) / 3);
  }

  > div {
    width: 100%;
    height: 100%;
    // border-top: 1px solid rgba(#191F25, 0.12);
    &.app_layer {
      width: auto !important;
      height: auto !important;
    }
  }
  .expressModle {
    padding-left: 16px;
    height: 44px;
    line-height: 44px;
    background: #e6f2fe;
    color: #006afe;
    img {
      margin-right: 4px;
      height: 18px;
      width: 18px;
    }
  }
  // 套餐到期
  .sku-tip {
    height: auto;
    background-color: #f5f5f5;
    .common-bar {
      margin: 12px 16px !important;
      margin-bottom: 0;
      border-radius: 8px;
    }
  }
}

.ff-ding {
  font-family: ding;
}
.ff-ding-bold {
  font-family: ding-bold;
}
.ff-ding-condensed-bold {
  font-family: ding-condensed-bold;
}
</style>
